// Animated Rio avatar — inspired by Google Assistant dots
export default function RioAvatar({ size = 40, animated = false, speaking = false }) {
  const s = size;
  return (
    <div style={{
      width: s, height: s, borderRadius: "50%",
      background: "linear-gradient(135deg, #1A3260, #2D5AA0)",
      display: "flex", alignItems: "center", justifyContent: "center",
      position: "relative", flexShrink: 0,
      boxShadow: speaking ? "0 0 12px rgba(26,50,96,0.4)" : "none",
      transition: "box-shadow 0.3s",
    }}>
      {/* R letter */}
      <svg width={s * 0.5} height={s * 0.5} viewBox="0 0 24 24" fill="none">
        <text x="4" y="19" fontFamily="Georgia, serif" fontSize="20" fontWeight="700" fill="#C5A572">R</text>
      </svg>
      {/* Animated dots ring */}
      {(animated || speaking) && (
        <div style={{ position: "absolute", inset: -3 }}>
          <svg width={s + 6} height={s + 6} viewBox="0 0 46 46">
            <circle cx="23" cy="23" r="21" fill="none" stroke="#C5A572" strokeWidth="1.5"
              strokeDasharray="4 8" opacity="0.6"
              style={{ animation: "spin 8s linear infinite" }} />
          </svg>
        </div>
      )}
      {/* Online dot */}
      <div style={{
        position: "absolute", bottom: 0, right: 0,
        width: s * 0.25, height: s * 0.25, borderRadius: "50%",
        background: "#22c55e", border: "2px solid #fff",
      }} />
      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
